/* eslint-disable @typescript-eslint/no-non-null-assertion */

export default function productsSearched({
  properties
}) {
  return {
    name: "Search",
    properties: {
      search_term: properties.query
    }
  };
}